import { useMediaQuery } from "@mui/material";
import { Drawer } from "../shared/Drawer";
import { LeadData } from "types";
import dayjs from "dayjs";
import { PiEnvelopeSimpleDuotone, PiPhoneFill } from "react-icons/pi";

type Props = {
    isOpen: boolean;
    onClose: () => void;
    viewLogDetails: LeadData;
    refetch?: () => void;
};

const ViewLogModal = ({
    isOpen, onClose, viewLogDetails, refetch
}: Props) => {
    const isMobile = useMediaQuery('(max-width:960px)');
    return (
        <Drawer
            fullWidth
            isOpen={isOpen}
            onClose={onClose}
            minHeight={'max-content'}
            borderRadius={isMobile ? '16px 16px 0px 0px' : '0px'}
            minWidth={!isMobile ? '390px' : '100%'}
            maxWidth={!isMobile ? '390px' : '100%'}
            maxHeight={isMobile ? '80dvh' : '100dvh'}
            backDropColor={isMobile ? 'rgba(0, 0, 0, 0.5)' : 'transparent'}
            boxShadow="0px -8px 32px 0px #00000040"
            position={isMobile ? 'bottom' : 'right'}
            header={
                <div className="flex flex-col pt-5 px-5">
                    <span className="text-[#1C1C28] font-inter text-[18px] font-[600] leading-[21.6px] mb-[6px]">{viewLogDetails?.name}</span>
                    <div>
                        <div className="flex gap-1 justify-start items-center">
                            <PiEnvelopeSimpleDuotone className="text-[#555770] w-[16px] h-[16px]" />
                            <p className="text-[#555770] font-inter text-[14px] font-[500] leading-[20px]">
                                {viewLogDetails?.email}
                            </p>
                        </div>
                        <div className="flex gap-2 justify-start items-center">
                            <PiPhoneFill className="text-[#555770] w-[16px] h-[16px]" />
                            <p className="text-[#555770] font-inter text-[14px] font-[500] leading-[20px]">
                                {viewLogDetails?.phone}
                            </p>
                        </div>
                    </div>
                    <div className="my-[16px]">
                        <p className="text-[#555770] text-sm">
                            Company: {viewLogDetails?.sourceCompanyName}
                        </p>
                    </div>
                    <div className="w-full h-[1.3px] flex-shrink-0 rounded bg-gray-200" />
                </div>
            }
            body={
                <div>
                    <p className="text-sm text-[#1C1C28] font-inter text-[18px] leading-[28px] font-[500] pt-[4px] pl-[19px]">Log History</p>
                    <div className="flex flex-col justify-between text-sm text-[#555770] w-full mt-[16px] px-[8px]">
                        {viewLogDetails?.callLogHistory?.map((log, index) => (
                            <div key={index} className="flex flex-col px-[8px] py-[8px]">
                                <div className="flex justify-start">
                                    <p className='self-stretch max-auto rounded-[6px] py-[2px] px-[10px] text-[12px] font-medium break-words leading-[18px] font-inter text-[#5521B5] bg-[#EDEBFE]'>{log.callLogsStatus}</p>
                                </div>
                                <p className="text-[#555770] my-[8px]">{log.remarks ? log.remarks : '--'}</p>
                                {log?.selectedDate && <p className="text-[#555770] text-sm">
                                    Follow-up call date: {dayjs(log.selectedDate).format('DD MMM YYYY h:mm A')}
                                </p>}
                                <div className="flex gap-2">
                                    <p className="text-[#555770]"> {log?.updatedBy?.name}</p>
                                    <p className="">•</p>
                                    <p className="text-[#555770]">
                                        {dayjs(log?.updatedAt).format('DD MMM YYYY, hh:mm A')}
                                    </p>
                                </div>

                                <div className="w-full h-[1.3px] flex-shrink-0 rounded bg-gray-200 mt-2" />
                            </div>
                        ))}
                    </div>
                </div>
            }
        />

    )
}

export default ViewLogModal;